<template>
  <v-container fluid class="rbu-volume-detail" v-if="volume">
    <v-row class="flex-grow-0">
      <v-btn
        text
        color="primary"
        exact
        :to="{ name: 'rbu-edition-detail', params: volume.edition.id }"
      >
        <h3 class="font-weight-regular">
          &lt;&lt; {{ $t("rbu.edition") }} {{ volume.edition.edition }}
        </h3>
      </v-btn>
    </v-row>

    <v-row class="rbu-volume-info-wrapper">
      <h3>{{ volume.name }}</h3>
      <v-btn
        v-if="canDeleteAndAddSection"
        color="primary"
        class="ml-4"
        small
        @click="createSection"
      >
        <v-icon>mdi-plus</v-icon>
        {{ $t("new") }}
      </v-btn>
      <v-btn color="primary" class="ml-4" small @click="goToRbuAdmin">
        <v-icon>mdi-account</v-icon>
        RBU User
      </v-btn>
    </v-row>

    <v-row class="flex-grow-1 rounded-b">
      <RbuSectionList
        full-height
        :extra-filters="{ volume_id: [$route.params.volumeId] }"
      ></RbuSectionList>
    </v-row>
  </v-container>
</template>
<script>
import { ACTION_TYPES } from "@/store/types";
import { computed, onMounted, ref } from "@vue/composition-api";
import RbuSectionList from "@/components/rbu/RbuSectionList.vue";
import CreateRbuSectionDialog from "@/components/rbu/CreateRbuSectionDialog.vue";
import { PERMISSIONS, USER_TYPE } from "@/constants";

export default {
  name: "RbuVolume",
  components: { RbuSectionList },
  setup(props, { root }) {
    const volume = ref(null);
    const canDeleteAndAddSection = computed(() => {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].includes(
        root.$store.getters.account.type
      );
    });
    const getVolume = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/volume/",
        params: { volume_id: root.$route.params.volumeId },
      });

      if (response.body.success) {
        volume.value = response.body.volume;
      }
    };

    const createSection = async function () {
      const sectionId = await root.$dialog.showAndWait(CreateRbuSectionDialog, {
        showClose: false,
        persistent: true,
        volumeId: root.$route.params.volumeId,
      });

      if (sectionId) {
        root.$router.push({
          name: "rbu-section-detail",
          params: { sectionId },
        });
      }
    };

    const goToRbuAdmin = async function () {
      if (volume.value) {
        root.$router.push({
          name: "rbu-admin-detail",
          params: { volume: volume.value.id },
        });
      }
    };

    onMounted(() => {
      getVolume();
    });

    return {
      volume,
      goToRbuAdmin,
      createSection,
      canDeleteAndAddSection,
    };
  },
};
</script>

<style lang="less">
.rbu-volume-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rbu-volume-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .rbu-volume-info {
      flex: 1 1 0;
    }
  }
}
</style>
